// const AJAX_URL = '/wp-admin/admin-ajax.php'

jQuery(document).ready(function($) {
  joints_wp_fixes();

  //navigation bar animations aka the top header menu animations
  $(".social").click(function(e) {
    e.preventDefault();
    $(".makeToggle").hide();
    $(".icon")
      .addClass("easeIt")
      .animate({ width: "show" }, 600);

    setTimeout(function() {
      $(".icon").addClass("addIt");
    }, 400);
    if ($("#funStuff").hasClass("icon noShow2 easeIt addIt")) {
      console.log("fuck");
      $(".hideAgain2").addClass("away");
    } else if (!$("#funStuff").hasClass("icon noShow2 easeIt addIt")) {
      console.log("fuck it");
      $(".hideAgain2").removeClass("away");
      // $('.hideAgain2').addClass('back');
    }
  });

  $(".searchIt").click(function(e) {
    console.log("searchIt clicked");
    e.preventDefault();
    if ($("#funStuff").hasClass("icon noShow2 easeIt addIt")) {
      $(".hideAgain2").addClass("away");
    } else if (!$("#funStuff").hasClass("icon noShow2 easeIt addIt")) {
      $(".hideAgain2").removeClass("away");
    }
  });

  $(".hideAgain").click(function(e) {
    e.preventDefault();
    setTimeout(function() {
      $(".icon").removeClass("addIt");
    }, 400);
    $(".fas.fa-search").removeClass("searchGray");
    $("#removeIt").show();
    $(".icon").animate({ width: "hide" }, { height: "0px" }, 1000);
    $(".bubble").animate({ width: "hide" }, { height: "0px" }, 800);
    $(".makeToggle")
      .delay("600")
      .fadeIn();
  });

  $(".searchIt").click(function() {
    $("#removeIt").hide();
    $(".fas.fa-search").addClass("searchGray");
    $(".makeToggle").hide();
    $(".bubble").animate({ width: "show" }, 800);
  });

  $(".hideAgain2").click(function() {
    $(".fas.fa-search").removeClass("searchGray");
    $("#removeIt").show();
    $(".bubble").animate({ width: "hide" }, { height: "0px" }, 800);
    $(".makeToggle")
      .delay("600")
      .fadeIn();
  });

  $(".searchIt").mouseenter(function() {
    $(".fas.fa-search").addClass("searchWhite");
  });

  $(".searchIt").mouseleave(function() {
    $(".fas.fa-search").removeClass("searchWhite");
  });

  if ($(".acquisition-nav").length > 0) {
    /*stick header*/
    $(function() {
      var elemTOff = 0;
      var winTOff = 0;
      var totalOff = 0;
      var elemTDist = $(".acquisition-nav").position().top - 50;

      $(window).scroll(function() {
        elemTOff = $(".acquisition-nav").offset().top;
        winTOff = $(window).scrollTop();
        totalOff = elemTOff - winTOff;

        if (totalOff < 0) {
          $(".acquisition-nav").addClass("sticky");
        } else if (winTOff < elemTDist) {
          $(".acquisition-nav").removeClass("sticky");
        }
      }); //on scroll
    });
  }
});
